export default function () {
  return {
    currentExercise: 0,
    currentStep: null,

    logs: {
      user_info: null,
      mouse_buttons_test: null,
      keyboard_buttons_test: null,
      keyboard_string_test: null,
    },
  };
}
